<template>
    <div v-if="isAbsolutelyStrategyEligible" class="malt-strategy-high-level-wrapper">
        <aside>
            <StrategyHighLevelBanner :reduced="!showOverlay" @reduce="showOverlay = false" @expand="showOverlay = true" />
            <div v-if="showOverlay" class="malt-strategy-high-level-wrapper__skip">
                <VJoyButton
                    :variant="isMobile ? 'ghost' : 'secondary'"
                    data-testid="strategy-high-level-banner-skip-btn"
                    @click="showOverlay = false"
                >
                    {{ $t('search.banner.malt.strategy.high.level.cta.skip') }}
                </VJoyButton>
            </div>
        </aside>
        <div :class="{'malt-strategy-high-level-wrapper__absolutely-eligible': showOverlay}">
            <slot />
        </div>
    </div>
    <slot v-else />
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useMediaQuery} from '@malt/utils';
    import {VJoyButton} from '@maltjoy/core-vue';
    import StrategyHighLevelBanner from './StrategyHighLevelBanner.vue';
    import {useSearchFeaturesStore} from '../../stores/search-features.store';

    const showOverlay = ref(true);

    const {matchMedia} = useMediaQuery();
    const isMobile = computed(() => matchMedia.value.max.Sm);

    const searchFeaturesStore = useSearchFeaturesStore();
    const {isAbsolutelyStrategyEligible} = storeToRefs(searchFeaturesStore);
</script>

<style scoped lang="scss">
    .malt-strategy-high-level-wrapper {
        &__skip {
            position: fixed;
            bottom: 0;
            z-index: 2;
            width: 100%;
            height: 140px;
            background: hsl(0deg 0% 98.8% / 90%);
            backdrop-filter: blur(3px);
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__absolutely-eligible {
            position: relative;
        }

        &__absolutely-eligible::after {
            content: '';
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: hsl(0deg 0% 98.8% / 90%);
            backdrop-filter: blur(3px);
        }
    }
</style>
